import type { MasterKind, MasterStatus } from '@mnc/contracts';

/** URL state of the registry page. */
export interface RegistrySearch {
  tab?: 'regions';
  q?: string;
  kind?: MasterKind;
  region?: string;
  status?: MasterStatus;
  entity?: string;
  sort?: string;
  page?: number;
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);

export function parseRegistrySearch(raw: Record<string, unknown>): RegistrySearch {
  const page = Number(raw.page);
  const kind = str(raw.kind);
  const status = str(raw.status);
  return {
    tab: raw.tab === 'regions' ? 'regions' : undefined,
    q: str(raw.q),
    kind: kind === 'beneficiary' ? 'beneficiary' : kind === 'stakeholder' ? 'stakeholder' : undefined,
    region: str(raw.region),
    status: status === 'active' || status === 'retired' || status === 'merged' ? status : undefined,
    entity: str(raw.entity),
    sort: str(raw.sort),
    page: Number.isInteger(page) && page > 1 ? page : undefined,
  };
}
